import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
import Gikam from 'gikam';
export default {
  props: {
    options: Object
  },
  data: function data() {
    return {
      active: false
    };
  },
  methods: {
    clickHandle: function clickHandle() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Gikam.window.activePageEditSettingItem(_this);

              case 2:
                Gikam.window.openSettingPanel({
                  title: _this.$i18n('pageEdit.tabPanel.setting'),
                  type: 'TabPanelSetting',
                  options: _this.options
                });

                _this.$emit('click');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  computed: {
    classObject: function classObject() {
      var classList = ['tab-panel-page-edit-wrapper', {
        active: this.active
      }];
      return classList;
    }
  }
};